import { render, staticRenderFns } from "./TopTabbar.vue?vue&type=template&id=6953aa29&scoped=true"
import script from "./TopTabbar.vue?vue&type=script&lang=js"
export * from "./TopTabbar.vue?vue&type=script&lang=js"
import style0 from "./TopTabbar.vue?vue&type=style&index=0&id=6953aa29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953aa29",
  null
  
)

export default component.exports